// THIS FILE IS AUTO-GENERATED. DO NOT EDIT BY HAND.
// To make changes, edit the following files and then run bin/generate_api_owners:
//   - common/code_ownership/domain_globs.yml
//   - common/code_ownership/team_domains.yml
//   - frontend/{gp,lp}/src/api/*.ts files listed in domain_globs.yml

// Maps API URL path prefixes to Sentry team names.
// Used by getApiOwner() to match the first path segment of an API URL via startsWith.
const apiOwners: Record<string, string> = {
  activity_log: 'im-communications',
  aggregation: 'im-financials-payments-performance',
  aggregations: 'im-financials-payments-performance',
  am_asset_groups: 'im-financials-payments-performance',
  am_asset_name_mappings: 'im-financials-payments-performance',
  am_dashboards: 'im-financials-payments-performance',
  am_kpi_mappings: 'im-financials-payments-performance',
  am_lease_expirations: 'im-financials-payments-performance',
  am_metrics: 'im-financials-payments-performance',
  am_report_asset_mapping_suggestions: 'im-financials-payments-performance',
  am_reports: 'im-financials-payments-performance',
  am_settings: 'im-financials-payments-performance',
  assets: 'im-financials-payments-performance',
  audit_events: 'im-communications',
  auth_apm: 'im-foundations',
  auth_events: 'im-foundations',
  auth_global_service: 'im-foundations',
  bank_accounts: 'im-financials-payments-performance',
  capital_call_items: 'im-financials-payments-performance',
  capital_calls: 'im-financials-payments-performance',
  cash_reserves_gl_accounts: 'im-financials-payments-performance',
  checklist_categories: 'im-communications',
  checklist_items: 'im-communications',
  checklist_templates: 'im-communications',
  contact_groups: 'im-communications',
  contact_preferences: 'im-communications',
  contact_us_form: 'im-communications',
  contact_us_form_settings: 'im-communications',
  contacts: 'im-communications',
  contributions: 'im-financials-payments-performance',
  custom_attribute_definitions: 'im-communications',
  custom_attribute_values: 'im-communications',
  deal_statuses: 'im-financials-payments-performance',
  deals: 'im-financials-payments-performance',
  distribution_approvers: 'im-financials-payments-performance',
  distribution_items: 'im-financials-payments-performance',
  distributions: 'im-financials-payments-performance',
  document_batch_items: 'im-communications',
  document_batches: 'im-communications',
  document_shares: 'im-communications',
  documentation: 'im-communications',
  documents: 'im-communications',
  email_campaign: 'im-communications',
  email_campaigns: 'im-communications',
  email_drafts: 'im-communications',
  email_notification_templates: 'im-communications',
  email_recipients: 'im-communications',
  email_templates: 'im-communications',
  emails: 'im-communications',
  entities: 'im-financials-payments-performance',
  exports: 'im-foundations',
  firm: 'im-foundations',
  funds: 'im-financials-payments-performance',
  hooks: 'im-communications',
  import: 'im-communications',
  investment_report: 'im-financials-payments-performance',
  investment_report_brand_settings: 'im-financials-payments-performance',
  investment_report_section: 'im-financials-payments-performance',
  investment_report_sections: 'im-financials-payments-performance',
  investment_reports: 'im-financials-payments-performance',
  investor_contacts: 'im-communications',
  investors: 'im-financials-payments-performance',
  ip: 'im-financials-payments-performance',
  ip_achs: 'im-financials-payments-performance',
  ip_batches: 'im-financials-payments-performance',
  ip_checksends: 'im-financials-payments-performance',
  ip_contributions: 'im-financials-payments-performance',
  ip_distribution_payees: 'im-financials-payments-performance',
  ip_onboarding: 'im-financials-payments-performance',
  ip_payment_agreement_addendum_signatures: 'im-financials-payments-performance',
  ip_payors: 'im-financials-payments-performance',
  ip_plaid_webhooks: 'im-financials-payments-performance',
  ip_webhooks: 'im-financials-payments-performance',
  loan_balance_gl_accounts: 'im-financials-payments-performance',
  login: 'im-foundations',
  maintenance: 'im-foundations',
  mfa: 'im-foundations',
  notes: 'im-communications',
  nylas_v3_auth: 'im-communications',
  nylas_v3_notifications: 'im-communications',
  oauth2: 'im-foundations',
  opportunities: 'im-communications',
  performance_measurement: 'im-financials-payments-performance',
  performance_measurement_batches: 'im-financials-payments-performance',
  performance_measurements: 'im-financials-payments-performance',
  performance_measurements_batches: 'im-financials-payments-performance',
  plaid: 'im-financials-payments-performance',
  positions: 'im-financials-payments-performance',
  prospect_contributions: 'im-financials-payments-performance',
  prospect_statuses: 'im-communications',
  prospects: 'im-communications',
  recurring_tasks: 'im-communications',
  report_batches: 'im-financials-payments-performance',
  report_draft: 'im-financials-payments-performance',
  report_drafts: 'im-financials-payments-performance',
  reporting_telemetry: 'im-financials-payments-performance',
  roles: 'im-foundations',
  search: 'im-foundations',
  sessions: 'im-foundations',
  settings: 'im-foundations',
  share_prices: 'im-financials-payments-performance',
  signature_packet_drafts: 'im-communications',
  signature_packet_templates: 'im-communications',
  signature_packets: 'im-communications',
  signature_recipients: 'im-communications',
  signature_signers: 'im-communications',
  statement_batches: 'im-financials-payments-performance',
  statement_template: 'im-financials-payments-performance',
  statement_templates: 'im-financials-payments-performance',
  task: 'im-communications',
  tasks: 'im-communications',
  users: 'im-foundations',
  withholding_configs: 'im-financials-payments-performance',
  withholdings: 'im-financials-payments-performance',
};

export default apiOwners;
